const initialState = {
  bookings: { data: { result: [] }, total: 0 },
  loading: false,
  addRewardPointsResult: null,
  updateLegalDocumentsResult: null,
};

export const bookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_BOOKINGS_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        bookings: null,
      };
    case "GET_BOOKINGS_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        bookings: action.payload,
      };
    case "GET_BOOKINGS_LIST_FAILED":
      return {
        ...state,
        loading: false,
        bookings: action.payload,
      };

    case "GET_BOOKING_REQUEST":
      return {
        ...state,
        loading: true,
        booking: null,
      };
    case "GET_BOOKING_SUCCESS":
      return {
        ...state,
        loading: false,
        booking: action.payload,
      };
    case "GET_BOOKING_FAILED":
      return {
        ...state,
        loading: false,
        booking: action.payload,
      };
    case "ADD_REWARD_POINTS_REQUEST":
      return {
        ...state,
        loading: true,
        addRewardPointsResult: null,
      };
    case "ADD_REWARD_POINTS_SUCCESS":
      return {
        ...state,
        loading: false,
        addRewardPointsResult: action.payload,
      };
    case "ADD_REWARD_POINTS_FAILED":
      return {
        ...state,
        loading: false,
        addRewardPointsResult: action.payload,
      };
    case "GET_PAYMENT_EXECUTIVE_LIST_REQUEST":
      return { ...state, loading: true, bookingsPaymentExec: null };
    case "GET_PAYMENT_EXECUTIVE_LIST_SUCCESS":
      return { ...state, loading: false, bookingsPaymentExec: action.payload };
    case "GET_PAYMENT_EXECUTIVE_LIST_FAILED":
      return { ...state, loading: false, bookingsPaymentExec: action.payload };
    case "UPDATE_LEGAL_DOCUMENTS_REQUEST":
      return {
        ...state,
        loading: true,
        updateLegalDocumentsResult: null,
      };
    case "UPDATE_LEGAL_DOCUMENTS_SUCCESS":
      return {
        ...state,
        loading: false,
        updateLegalDocumentsResult: action.payload,
      };
    case "UPDATE_LEGAL_DOCUMENTS_FAILED":
      return {
        ...state,
        loading: false,
        updateLegalDocumentsResult: action.payload,
      };
    case "CANCEL_BOOKING_REQUEST":
      return {
        ...state,
        loading: true,
        cancelBookingResult: null,
      };
    case "CANCEL_BOOKING_SUCCESS":
      return {
        ...state,
        loading: false,
        cancelBookingResult: action.payload,
      };
    case "CANCEL_BOOKING_FAILED":
      return {
        ...state,
        loading: false,
        cancelBookingResult: action.payload,
      };

    default:
      return state;
  }
};
